import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import InputField from '../../../form/InputField/InputField'; 

const ProposalHiddenField = ({ onValueChange }) => {
    const defaultUUID = "00000000-0000-0000-0000-000000000000";
    const [value, setValue] = useState(defaultUUID);
    const [isVisible, setIsVisible] = useState(false);

    // Expõe o método para exibir o campo
    useEffect(() => {
        window.idProposta = {
            show: () => {
                setIsVisible(true);
                console.log('Campo ID da proposta exibido');
                return true;
            }
        };

        // Informa o componente pai sempre que o valor mudar
        onValueChange?.(value);

        return () => {
            delete window.idProposta;
        };
    }, [value, onValueChange]);

    // Se não estiver visível, não renderiza nada
    if (!isVisible) return null;

    return (
        <InputField
            id="idPropostaAnaliseCredito"
            label="ID PAC:"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            type="text"
        />    );
};

ProposalHiddenField.propTypes = {
    onValueChange: PropTypes.func
};

export default ProposalHiddenField;